// SDK version string. esbuild rewrites the __SDK_VERSION__ token at build
// time (define: { __SDK_VERSION__: ... } in esbuild.config.mjs). The
// fallback string only fires when the file is loaded by a tool that
// doesn't substitute defines (rare; mostly editor tooling).
declare const __SDK_VERSION__: string;

export const VERSION: string =
  typeof __SDK_VERSION__ === "string" ? __SDK_VERSION__ : "0.0.0-dev";
